module.exports = __webpack_public_path__ + "img/doorLogo10.986ffaec.png";